var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noMoreContent",class:_vm.extClass,attrs:{"id":"noMoreContent"}},[_c('div',{staticClass:"tips",domProps:{"textContent":_vm._s(_vm.tips)}})])}
var staticRenderFns = []

export { render, staticRenderFns }